import styled from '@emotion/styled'
import { css } from '@emotion/react'
import PropTypes from 'prop-types'

const smallSize = theme => css`
  font-size: ${theme.fontSize.base};
`

const largeSize = theme => css`
  font-size: ${theme.fontSize.large};
`

const sizes = (props = {}) => css`
  ${props.size === 'small' && smallSize(props.theme)};
  ${props.size === 'large' && largeSize(props.theme)};
`

const SidebarLabel = styled('div')`
  ${sizes};
  letter-spacing: normal;
  color: ${({ color }) => color || 'inherit'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`

SidebarLabel.propTypes = {
  size: PropTypes.oneOf(['large', 'small']),
}

SidebarLabel.defaultProps = {
  size: 'small',
}

export default SidebarLabel
